"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var reconnect_js_1 = require("reconnect.js");
var antd_1 = require("antd");
var CartList_1 = __importDefault(require("../../Components/CartList"));
var CheckoutForm_1 = __importDefault(require("../../Components/CheckoutForm"));
var CheckoutSummary_1 = __importDefault(require("../../Components/CheckoutSummary"));
var Cart = __importStar(require("../../Actions/Cart"));
var User = __importStar(require("../../Actions/User"));
var NavUrl_1 = __importStar(require("../../Utils/NavUrl"));
var CheckoutPageWrapper_1 = __importDefault(require("../../Components/CheckoutPageWrapper"));
var Coupon_1 = __importDefault(require("./Coupon"));
var Points_1 = __importDefault(require("./Points"));
function CheckoutReviewPage(props) {
  var _this = this;
  var _a;
  var _b = react_1.default.useState(null),
    privateProfile = _b[0],
    setPrivateProfile = _b[1];
  var _c = props.enableInvoiceFeature,
    enableInvoiceFeature = _c === void 0 ? false : _c,
    _d = props.renderCustomComponent,
    renderCustomComponent = _d === void 0 ? null : _d,
    _e = props.renderCustomDiscountComponent,
    renderCustomDiscountComponent = _e === void 0 ? null : _e,
    cartItemCustomRenderer = props.cartItemCustomRenderer,
    cartListCustomRenderer = props.cartListCustomRenderer,
    _f = props.checkoutFormProps,
    checkoutFormProps = _f === void 0 ? {} : _f,
    _g = props.checkoutSummaryProps,
    checkoutSummaryProps = _g === void 0 ? {} : _g,
    _h = props.cartListDefaultExpand,
    cartListDefaultExpand = _h === void 0 ? false : _h,
    _j = props.stickyTop,
    clientStickyTop = _j === void 0 ? null : _j,
    _k = props.pageContext.pageId,
    pageId = _k === void 0 ? 'rev-CheckoutReviewPage' : _k;
  var user = reconnect_js_1.useOutlet('user')[0];
  var cart = reconnect_js_1.useOutlet('cart')[0];
  var _l = react_1.default.useState(''),
    couponCodeUsed = _l[0],
    setCouponCodeUsed = _l[1];
  var _m = react_1.default.useState(false),
    isFullPointUsed = _m[0],
    setIsFullPointUsed = _m[1];
  var _o = react_1.default.useState(clientStickyTop),
    stickyTop = _o[0],
    setStickyTop = _o[1];
  var sideElemRef = react_1.default.useRef(null);
  react_1.default.useLayoutEffect(function () {
    if (sideElemRef.current && clientStickyTop === null) {
      var top_1 = sideElemRef.current.getBoundingClientRect().top;
      console.log('get stickyTop', top_1);
      setStickyTop(top_1);
    }
  }, [clientStickyTop]);
  var usedCoupon = (_a = cart.discount_items.find(function (i) {
    return i.type === 'coupon';
  })) === null || _a === void 0 ? void 0 : _a.coupon;
  var usedPoints = cart.discount_items.find(function (i) {
    return i.type === 'points';
  });
  var AppActions = reconnect_js_1.useOutlet('actions')[0];
  react_1.default.useEffect(function () {
    function getPrivateProfile() {
      return __awaiter(this, void 0, void 0, function () {
        var _privateProfile;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, User.getPrivateProfile()];
            case 1:
              _privateProfile = _a.sent();
              setPrivateProfile(_privateProfile);
              return [2 /*return*/];
          }
        });
      });
    }

    if (user && !user.tmp) {
      getPrivateProfile();
    }
  }, [user]);
  function checkAllowNextStep(cart) {
    var addressFields = cart.receiver_zip && cart.receiver_city && cart.receiver_district && cart.receiver_address && cart.buyer_zip && cart.buyer_city && cart.buyer_district && cart.buyer_address;
    var commonCheckFields = cart.items.length > 0 && cart.payment_subtype && cart.logistics_type && cart.buyer_name && cart.buyer_phone && cart.buyer_email && cart.receiver_name && cart.receiver_phone && cart.receiver_email;
    if (cart.logistics_type === Cart.LOGISTICS_TYPE.cvs) {
      return commonCheckFields && !!cart.logistics_cvs_store_id;
    } else if (cart.logistics_type === Cart.LOGISTICS_TYPE.home) {
      return commonCheckFields && addressFields;
    } else {
      return commonCheckFields;
    }
  }
  var handleCheckout = function handleCheckout() {
    return __awaiter(_this, void 0, void 0, function () {
      var ex_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!props.handleCheckout) return [3 /*break*/, 2];
            return [4 /*yield*/, props.handleCheckout(usedCoupon === null || usedCoupon === void 0 ? void 0 : usedCoupon.code, isFullPointUsed)];
          case 1:
            if (_a.sent()) {
              return [2 /*return*/];
            }

            _a.label = 2;
          case 2:
            if (cart.payment_subtype === 'paypal') {
              return [2 /*return*/, Cart.checkoutRequest(usedCoupon === null || usedCoupon === void 0 ? void 0 : usedCoupon.code, isFullPointUsed)];
            }
            _a.label = 3;
          case 3:
            _a.trys.push([3, 6,, 7]);
            AppActions.setLoading(true);
            return [4 /*yield*/, AppActions.delay(600)];
          case 4:
            _a.sent();
            return [4 /*yield*/, Cart.checkoutRequest(usedCoupon === null || usedCoupon === void 0 ? void 0 : usedCoupon.code, isFullPointUsed)];
          case 5:
            _a.sent();
            return [3 /*break*/, 7];
          case 6:
            ex_1 = _a.sent();
            console.warn(ex_1);
            AppActions.setLoading(false);
            return [3 /*break*/, 7];
          case 7:
            return [2 /*return*/];
        }
      });
    });
  };

  var onPaypalApprove = function onPaypalApprove(paypalOrderId) {
    return __awaiter(_this, void 0, void 0, function () {
      var ex_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            AppActions.setLoading(true);
            return [4 /*yield*/, Cart.capturePaypalCheckout(paypalOrderId, usedCoupon === null || usedCoupon === void 0 ? void 0 : usedCoupon.code, isFullPointUsed)];
          case 1:
            _a.sent();
            return [3 /*break*/, 3];
          case 2:
            ex_2 = _a.sent();
            console.warn(ex_2);
            AppActions.setLoading(false);
            return [3 /*break*/, 3];
          case 3:
            return [2 /*return*/, null];
        }
      });
    });
  };
  var hasCouponFeat = !!reconnect_js_1.getOutlet('FeatureOptions').getValue().coupon;
  var hasPointsFeat = !!reconnect_js_1.getOutlet('FeatureOptions').getValue().points;
  function shouldDisableDiscount() {
    var _a;
    if (!usedCoupon && !usedPoints && cart.total === 0) {
      return true;
    }
    for (var _i = 0, _b = Array.isArray(cart.items) && cart.items || []; _i < _b.length; _i++) {
      var it_1 = _b[_i];
      if ((_a = it_1.product) === null || _a === void 0 ? void 0 : _a.disable_discount) {
        return true;
      }
    }
    return false;
  }
  var forceDisableDiscount = shouldDisableDiscount();
  return react_1.default.createElement(Wrapper, {
    id: pageId,
    stickyTop: stickyTop
  }, react_1.default.createElement("div", {
    className: "container"
  }, react_1.default.createElement("div", {
    className: "main"
  }, cart.items.length === 0 && react_1.default.createElement("div", null, react_1.default.createElement("h3", {
    style: {
      margin: '10px 0'
    }
  }, AppActions.L('cart_empty_title')), react_1.default.createElement(antd_1.Button, {
    onClick: function onClick() {
      return AppActions.navigate(NavUrl_1.default.from(NavUrl_1.PredefinedRoute.products));
    }
  }, AppActions.L('shopping'))), cart.items.length > 0 && react_1.default.createElement(CartList_1.default, {
    cartItems: cart.items,
    disabled: true,
    renderCustomComponent: renderCustomComponent,
    cartItemCustomRenderer: cartItemCustomRenderer,
    cartListCustomRenderer: cartListCustomRenderer,
    defaultExpand: cartListDefaultExpand
  }), react_1.default.createElement(CheckoutForm_1.default, __assign({
    disabled: true,
    style: {
      marginTop: 30
    },
    enableInvoiceFeature: enableInvoiceFeature
  }, checkoutFormProps))), react_1.default.createElement("div", {
    className: "gutter"
  }), react_1.default.createElement("div", {
    className: "side",
    ref: sideElemRef
  }, react_1.default.createElement(CheckoutSummary_1.default, __assign({
    lastStep: true,
    cart: cart,
    disabled: !checkAllowNextStep(cart),
    onClick: handleCheckout,
    onPaypalApprove: onPaypalApprove,
    onPrevClick: function onPrevClick() {
      AppActions.navigate(NavUrl_1.default.from(NavUrl_1.PredefinedRoute.checkoutInfo));
    },
    buttonLabel: "\u7D50\u5E33"
  }, checkoutSummaryProps), typeof renderCustomDiscountComponent === 'function' && renderCustomDiscountComponent({
    cart: cart
  }), (hasCouponFeat || hasPointsFeat) && user && !user.tmp && !forceDisableDiscount && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(antd_1.Divider, {
    orientation: "center"
  }, "\u512A\u60E0\u5238"), react_1.default.createElement("div", {
    className: "discounts-info"
  }, hasCouponFeat && react_1.default.createElement(Coupon_1.default, {
    privateProfile: privateProfile,
    usedCoupon: usedCoupon,
    onUseCoupon: function onUseCoupon(couponCode) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, Cart.onUseDiscount({
                coupon: couponCode,
                use_full_points: isFullPointUsed,
                points: 0,
                gift_points: 0
              })];
            case 1:
              _a.sent();
              setCouponCodeUsed(couponCode);
              return [2 /*return*/];
          }
        });
      });
    }
  }), privateProfile && hasPointsFeat && react_1.default.createElement(Points_1.default, {
    privateProfile: privateProfile,
    usedPoints: usedPoints,
    onUsePoints: function onUsePoints(useFullPoint) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, Cart.onUseDiscount({
                coupon: couponCodeUsed,
                use_full_points: useFullPoint,
                points: 0,
                gift_points: 0
              })];
            case 1:
              _a.sent();
              setIsFullPointUsed(useFullPoint);
              return [2 /*return*/];
          }
        });
      });
    }
  }), (usedPoints || usedCoupon) && react_1.default.createElement(antd_1.Alert, {
    message: react_1.default.createElement("span", null, "\u904B\u8CBB\u7121\u6CD5\u4F7F\u7528", react_1.default.createElement("span", {
      className: "point"
    }, react_1.default.createElement("label", null, "\u7D05\u5229")), "\u6216\u6298\u6263\u5238\u6298\u62B5"),
    type: "warning",
    showIcon: true
  }), usedPoints && react_1.default.createElement(antd_1.Alert, {
    message: react_1.default.createElement("span", null, react_1.default.createElement("span", {
      className: "point"
    }, react_1.default.createElement("label", null, "\u7D05\u5229")), "\u4F7F\u7528\u5F8C\u82E5\u8A02\u55AE\u56E0\u903E\u671F\u7B49\u56E0\u7D20\u5931\u6548\uFF0C\u5C07\u4E0D\u4E88\u9000\u9084\uFF0C\u8ACB\u898B\u8AD2\uFF01"),
    type: "warning",
    showIcon: true
  })))))));
}
var Wrapper = styled_components_1.default(CheckoutPageWrapper_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & > .container {\n    & > .side {\n      & .discounts-info {\n        display: flex;\n        flex-direction: column;\n        align-items: stretch;\n\n        & > * {\n          margin-bottom: 10px;\n          &:last-child {\n            margin-bottom: 0;\n          }\n        }\n      }\n    }\n  }\n"], ["\n  & > .container {\n    & > .side {\n      & .discounts-info {\n        display: flex;\n        flex-direction: column;\n        align-items: stretch;\n\n        & > * {\n          margin-bottom: 10px;\n          &:last-child {\n            margin-bottom: 0;\n          }\n        }\n      }\n    }\n  }\n"])));
exports.default = CheckoutReviewPage;
var templateObject_1;